import clsx from 'clsx';

/**
 * Card — universal bounded container.
 *
 * Props:
 *   variant   - "default" | "subtle" | "elevated" | "ghost"
 *   padding   - "none" | "sm" | "md" | "lg" (default) | "xl"
 *   radius    - "lg" | "xl" | "2xl" (default) | "3xl"
 *   hover     - enables lift-on-hover transition
 *   className - merged (override anything internal with utilities)
 */
const VARIANTS = {
  default:  'bg-card border border-soft shadow-card',
  subtle:   'bg-page border border-soft',
  elevated: 'bg-card border border-med shadow-hover',
  ghost:    'bg-transparent border border-transparent',
};

const PADDINGS = { none: '', sm: 'p-2', md: 'p-3', lg: 'p-4', xl: 'p-5' };

const RADII = {
  lg:    'rounded-lg',
  xl:    'rounded-xl',
  '2xl': 'rounded-2xl',
  '3xl': 'rounded-3xl',
};

export function Card({
  children,
  variant   = 'default',
  padding   = 'lg',
  radius    = '2xl',
  hover     = false,
  className = '',
  onClick,
  as: Tag   = 'div',
  ...rest
}) {
  return (
    <Tag
      onClick={onClick}
      className={clsx(
        'font-sans',
        VARIANTS[variant],
        PADDINGS[padding],
        RADII[radius],
        onClick && 'cursor-pointer',
        hover && 'transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-0.5 hover:shadow-hover',
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}
